module.exports = __webpack_public_path__ + "img/Metastasis-GBM_SPATA.678be744.png";